import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ViewChild,
  AfterViewInit
} from '@angular/core';

@Component({
  selector: 'axis-radio',
  templateUrl: './radio-button.component.html',
  host: {
    class: 'axis-radio'
  }
})
export class RadioButtonComponent implements OnInit, AfterViewInit {
  @Input() public ariaLabel: string;
  @Input() tabIndex: any;
  @Input() heading = '';
  // tslint:disable-next-line: no-input-rename
  @Input('cid') id: string;
  @Input() disabled: boolean;
  @Input() checked: boolean;
  @Input() name: string;
  @Input() value: string | number | boolean;
  @Input() rel: string;
  @Output() changeDetect = new EventEmitter();
  @Output() onChangeEvent = new EventEmitter();
  @Output() emitBlurEvent = new EventEmitter();
  @ViewChild('label') labelSection: any;
  // @HostBinding('class.axis-radio') axisRadio = true;

  constructor(public _changeDetRef: ChangeDetectorRef) {}

  ngOnInit() {
    if (!this.id) {
      this.id = (Math.random() + Math.random()).toString().replace('.', '');
    }
  }
  ngAfterViewInit(): void {
    const innerHTML = this.labelSection.nativeElement.innerHTML;
    if (!innerHTML) {
      this.labelSection.nativeElement.innerHTML = this.heading;
    } else {
      this.labelSection.nativeElement.innerHTML = (this.heading || '') + ' ' + innerHTML;
    }
  }

  onChange(e) {
    const modelVal = {
      name: this.name,
      value: this.value
    };
    this.onChangeEvent.emit(modelVal);
    this.changeDetect.emit(e.target.checked);
  }
  emitOnBlurEvent() {
    this.emitBlurEvent.emit();
  }
}
